import React, { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  UCPList,
  Overview,
  Notes,
  Snapshot,
  Garage,
  Appointments,
  RepairsOrders,
  Tasks,
  TestEmail,
} from "./pages";
import { FloatingButton } from "@ann/web-components";
import Header from "./components/Header/Header";
import { UCPPageContainer, ContainerWrapper } from "./UCPPage.styled";
import { BreadcrumbContainer, Navigator, Chat } from "./components";
import SectionShell from "./components/SectionShell";

const UCPPage = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const location = useLocation();

  // Extract contactId from URL path since nested routes define :contactId
  // URL pattern: /v1/ucp/:contactId/section
  const pathParts = location.pathname.split('/');
  const ucpIndex = pathParts.indexOf('ucp');
  const contactId = ucpIndex !== -1 && pathParts.length > ucpIndex + 1 
    ? pathParts[ucpIndex + 1] 
    : undefined;

  // Determinar si estamos en UCPList (ruta index)
  const isUCPList = location.pathname === "/v1/ucp" || location.pathname.endsWith("/ucp");

  const handleOpenChat = () => {
    setIsChatOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <ContainerWrapper>
      <UCPPageContainer>
        <Routes>
          <Route index element={<UCPList />} />
          <Route path="test-email" element={
            <SectionShell>
              <TestEmail />
            </SectionShell>
          } />
          <Route path=":contactId">
            <Route path="overview/*" element={
              <SectionShell >
                <Overview />
              </SectionShell>
            } />
            <Route path="activity/*" element={
              <SectionShell >
                <Notes />
              </SectionShell>
            } />
            <Route path="snapshot" element={
              <SectionShell >
                <Snapshot />
              </SectionShell>
            } />
            <Route path="garage" element={
              <SectionShell >
                <Garage />
              </SectionShell>
            } />
            <Route path="appointments" element={
              <SectionShell >
                <Appointments />
              </SectionShell>
            } />
            <Route path="repairs-orders" element={
              <SectionShell >
                <RepairsOrders />
              </SectionShell>
            } />
            <Route path="tasks" element={
              <SectionShell >
                <Tasks />
              </SectionShell>
            } />

          </Route>
          
        </Routes>
      </UCPPageContainer>
      {!isUCPList && !isChatOpen && (
        <FloatingButton
          bottom="70px"
          iconLeft="aiChat"
          label=""
          pill
          right="54px"
          size="large"
          type="primary"
          onClick={handleOpenChat}
        />
      )}
      <Chat
        open={isChatOpen}
        onClose={handleCloseChat}
        contactId={contactId}
      />
    </ContainerWrapper>
  );
};

export default UCPPage;
